// src/components/categories/Table/CategoriesTableColumns.jsx

const CategoriesTableColumns = [
    { id: "image", labelAr: "الصورة", labelEn: "Image", sortable: false },
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "parent", labelAr: "التصنيف الأب", labelEn: "Parent Category", sortable: false },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default CategoriesTableColumns;
